<template>
    <div>
        <div>
            <el-tooltip :content="order.created_time" placement="top" effect="light">
                <span>{{ order.the_id }}</span>
            </el-tooltip>
        </div>
        <div>
            <el-link :underline="false" type="primary"
                     :href="base_id_url(order.order_base.base_id)" target="_blank">
                <span>{{ order.order_base.base_id }}</span></el-link>

            <el-tooltip content="复制款号" placement="top" effect="light">
                <el-link @click="copySuccess()" class="copy-btn" :data-clipboard-text="order.order_base.base_id"
                         :underline="false" icon="el-icon-copy-document"></el-link>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseIdCol",
        props: {
            order: Object,
        },
        methods: {
            base_id_url(base_id) {
                return `/depository/?base_id=${base_id}`;
            },
            copySuccess() {
                this.$message.success(`复制款号:${this.order.order_base.base_id}成功`);
            },
        },
    }
</script>

<style scoped>

</style>